import { render, staticRenderFns } from "./PosPromotionList.vue?vue&type=template&id=d689923e&scoped=true&"
import script from "./PosPromotionList.vue?vue&type=script&lang=js&"
export * from "./PosPromotionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d689923e",
  null
  
)

export default component.exports